import { Action } from "redux"

import * as actions from "./actions"

export const initialState: ResourceFooter.Footer = {
    isLoading: false,
    buttons: [],
    itemId: -1,
}

const ACTION_HANDLERS: {
    [action: string]: (
        state: ResourceFooter.Footer,
        props: Action,
    ) => ResourceFooter.Footer
} = {
    [actions.INITIALIZE]: (
        state,
        { itemId }: actions.Initialize,
    ): ResourceFooter.Footer => ({
        ...state,
        itemId,
    }),

    [actions.REQUEST_STATE_TRANSITION_BUTTONS]: (
        state,
    ): ResourceFooter.Footer => ({
        ...state,
        isLoading: true,
    }),

    [actions.CLICK_STATE_TRANSITION_BUTTON]: (
        state,
    ): ResourceFooter.Footer => ({
        ...state,
        isLoading: true,
    }),

    [actions.RECEIVE_STATE_TRANSITION_BUTTONS]: (
        state,
        { buttons }: actions.ReceiveStateTransitionButtons,
    ): ResourceFooter.Footer => ({
        ...state,
        isLoading: false,
        buttons: buttons,
    }),
}

export default function reducer(
    state = initialState,
    action: Action,
): ResourceFooter.Footer {
    const handler: (
        state: ResourceFooter.Footer,
        action: Action,
    ) => ResourceFooter.Footer = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
